import { defineMessages } from 'react-intl';
import globalIntl from 'globalIntl'; // eslint-disable-line import/no-unresolved

const m = defineMessages({
  deploy: {
    id: 'deploy',
    defaultMessage: 'Deploy',
  },
  files: {
    id: 'files',
    defaultMessage: 'Files',
  },
  newPage: {
    id: 'newPage',
    defaultMessage: 'New Page',
  },
  newFolder: {
    id: 'newFolder',
    defaultMessage: 'New Folder',
  },
  newFile: {
    id: 'newFile',
    defaultMessage: 'New File',
  },
  selectOrCreateFile: {
    id: 'selectOrCreateFile',
    defaultMessage: 'Select or create a new file or folder.',
  },
  launchScript: {
    id: 'launchScript',
    defaultMessage: 'Launch',
  },
  shareScript: {
    id: 'shareScript',
    defaultMessage: 'Share script',
  },
  editCredentials: {
    id: 'editCredentials',
    defaultMessage: 'Edit Corezoid credentials',
  },
  openProcess: {
    id: 'openProcess',
    defaultMessage: 'Go to Corezoid process',
  },
});

export default { ...globalIntl, ...m };
